import { render, staticRenderFns } from "./Socrates.vue?vue&type=template&id=32be84af&"
import script from "./Socrates.vue?vue&type=script&lang=js&"
export * from "./Socrates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports